import React, { useEffect, useState } from 'react';
import { Container, Typography, InputLabel, Paper, Divider, Grid, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { MerchantActions, NotificationActions } from '../../../store';
import CancelIcon from '@material-ui/icons/HighlightOff';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },
    permission: {
        padding: '5px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantOrAcquirerProfile = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);
   
    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token, userData, permissions } = useSelector(IdentitySelector);

    const { classes, data } = props;

    /**
     *
     * 解約申請ボタン押下時の処理
     *
     */
    const onCancellationClick = () => {
        props.onCancelletionApplying();
    }

    var title = '';
    var cancellationButton = <div></div>;
    var externalLinkCdTitleElement = '';
    var externalLinkCdValueElement = '';
    switch (editing.merchant_type) {
        // 代表加盟店情報
        case 'acquirer':
            title = <Grid item xs={12}>
                <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepTwo.Acquirer" />}</Typography>
                <Divider />
            </Grid>;
            break;
        // 加盟店情報
        case 'general':
            title = <Grid item xs={12}>
                <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepTwo" />}</Typography>
                <Divider />
            </Grid>;
            if (userData.is_owner != null && userData.is_owner == true) {
                // ログインユーザがオーナーの場合
                if (editing.status == 3) {
                    // 状態が3:登録完了のときのみ解約申請ボタンを表示
                    cancellationButton = <Grid container item xs={12} spacing={2} justify="center">
                        <Grid item xs={3} sm={6}>
                            <Button fullWidth variant="contained" size="medium" color="secondary"
                                onClick={onCancellationClick}
                                startIcon={<CancelIcon />}><FormattedMessage id="Button.CancellationApplication" /></Button>
                        </Grid>
                    </Grid>;
                }
            }
            // 加盟店の場合のみ外部連携コードを表示
            externalLinkCdTitleElement =
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ExternalLinkCd"} /></InputLabel>
                </Grid>;
            externalLinkCdValueElement =
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.external_link_cd}</InputLabel>
                </Grid>;
            break;
    }

    // 事業形態
    var businessForm = '';
    switch (editing.business_form) {
        case 1:
            // 法人
            businessForm = <FormattedMessage id={"Merchant.Corporate"} />;
            break;
        case 2:
            // 個人事業主
            businessForm = <FormattedMessage id={"Merchant.IndividualBusiness"} />;
            break;
    }

    // 法人種別コード種別
    var shopCdtype = '';
    switch (editing.shop_cd_type) {
        case 1:
            // OKICA独自
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeOkica"} />;
            break;
        case 2:
            // JPQR
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeJPQR"} />;
            break;
    }

    // 精算サイクル
    var paymentCycle = '';
    switch (editing.payment_cycle) {
        case 1:
            // 月1回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle1"} />;
            break;
        case 2:
            // 月2回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle2"} />;
            break;
        case 2:
            // 月4回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle3"} />;
            break;
    }

    // アカウント区分
    var role = '';
    switch (editing.user_account_create_request.role) {
        case 1:
            // システム管理者
            role = <FormattedMessage id={"Account.Role.SystemAdmin"} />;
            break;
        case 2:
            // 沖縄IC
            role = <FormattedMessage id={"Account.Role.Brand"} />;
            break;
        case 3:
            // 代表加盟店
            role = <FormattedMessage id={"Account.Role.Acquirer"} />;
            break;
        case 4:
            // 一般加盟店
            role = <FormattedMessage id={"Account.Role.Merchant"} />;
            break;
        case 5:
            // 店舗
            role = <FormattedMessage id={"Account.Role.Store"} />;
            break;
    }

    // 設立年月日
    var establishmentDt = '';
    if (editing.establishment_dt != null && editing.establishment_dt != undefined) {
        var dt = new Date(editing.establishment_dt);
        establishmentDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 資本金
    var capital = '';
    if (editing.capital != null && editing.capital != undefined && editing.capital != '' && !isNaN(editing.capital)) {
        capital = Number(editing.capital).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }
    // 年商
    var annualSale = '';
    if (editing.annual_sale != null && editing.annual_sale != undefined && editing.annual_sale != '' && !isNaN(editing.annual_sale)) {
        annualSale = Number(editing.annual_sale).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }

    // 状態
    var status = '';
    switch (editing.status) {
        case 1:
            status = <FormattedMessage id={"Merchant.Status.Applying"} />;
            break;
        case 2:
            status = <FormattedMessage id={"Merchant.Status.CheckPassed"} />;
            break;
        case 3:
            status = <FormattedMessage id={"Merchant.Status.Registered"} />;
            break;
        case 4:
            status = <FormattedMessage id={"Merchant.Status.CancelletionApplying"} />;
            break;
        case 2:
            status = <FormattedMessage id={"Merchant.Status.Cancel"} />;
            break;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2} >   
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Profile.Title" />}</Typography>
                    </Grid>

                    {title}
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{businessForm}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNameInFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel1"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_1}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel2"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_2}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{shopCdtype}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NameInEng"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_e_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PostalCode"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_postal_code}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Place"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_address}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FaxNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_fax}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Capital"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{capital}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AnnualSales"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{annualSale}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.EstablishDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{establishmentDt}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfEmployees"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.employees_number}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfStores"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.temp_number}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustryCategory"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.category_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustrySubCategory"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.subcategory_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessDetail"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.business_content}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PaymentCycle"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{paymentCycle}</InputLabel>
                    </Grid>

                    {externalLinkCdTitleElement}
                    {externalLinkCdValueElement}

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Status"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{status}</InputLabel>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepSix" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.user_account_create_request.name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Division"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{role}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.MailAddress"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.user_account_create_request.username}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Account.Permission"} /></InputLabel>
                    </Grid>
                    {Object.keys(editing.user_account_create_request.permissions).map((fld) => {
                        var permission = editing.user_account_create_request.permissions[fld];
                        return (
                            <Grid container className={classes.permission} spacing={2}>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    <InputLabel component="legend">{permission.type.name}</InputLabel>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel component="legend">{permission.value.title}</InputLabel>
                                </Grid>
                            </Grid>
                        )
                    })}
                    {cancellationButton}
                </Grid>
            </Paper>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantOrAcquirerProfile);
 